const childrenOf = (node) => (
  Array.isArray(node && node.children) ? node.children : []
);

const isLeafCategory = (item) => childrenOf(item).length === 0;

const withLeafFlag = (items) => items.map((item) => {
  const copy = {};
  for (const key in item) {
    if (Object.prototype.hasOwnProperty.call(item, key)) {
      copy[key] = item[key];
    }
  }
  copy.isLeaf = isLeafCategory(item);
  return copy;
});

const buildState = (roots, path) => ({
  roots,
  path,
  items: withLeafFlag(childrenOf(path[path.length - 1])),
  currentRootId: path.length ? path[0].id : null,
});

const createCategoryNavigator = (roots) => {
  const safeRoots = Array.isArray(roots) ? roots : [];
  return safeRoots.length
    ? buildState(safeRoots, [safeRoots[0]])
    : {
      roots: [],
      path: [],
      items: [],
      currentRootId: null,
    };
};

const enterCategory = (state, item) => {
  if (!item || item.isLeaf || isLeafCategory(item)) {
    throw new Error("Cannot enter a leaf category");
  }
  return buildState(state.roots, state.path.concat(item));
};

const goBackCategory = (state) => (
  state.path.length > 1
    ? buildState(state.roots, state.path.slice(0, -1))
    : state
);

const selectRootCategory = (state, root) => (
  buildState(state.roots, [root])
);

module.exports = {
  createCategoryNavigator,
  enterCategory,
  goBackCategory,
  isLeafCategory,
  selectRootCategory,
};



// WEBPACK FOOTER //
// ./src/util/categoryNavigator.js